import { p, strong, hr, wrapHTML } from './htmlUtils';

/**
 * Format Twitter thread data as HTML (matches TwitterRenderer.tsx)
 */
export const formatTwitterHTML = (data: any): string => {
  if (!data || !data.tweets) {
    return wrapHTML(p('No Twitter content available'));
  }

  const sections: string[] = [];

  // Header
  const contentType = data.content_type || 'thread';
  sections.push(
    p(
      `${strong('Type:')} ${contentType} (${data.tweets.length} ${
        data.tweets.length === 1 ? 'tweet' : 'tweets'
      })`,
    ),
  );

  // Individual tweets
  const tweets = data.tweets.map((tweet: any) => {
    const tweetParts: string[] = [];

    // Tweet indicator
    tweetParts.push(
      p(
        strong(`Tweet ${tweet.position}/${data.tweets.length}${tweet.thread_indicator ? ' • ' + tweet.thread_indicator : ''}`),
      ),
    );

    // Content
    tweetParts.push(p(tweet.content.replace(/\n/g, '<br/>')));

    // Hashtags
    if (tweet.hashtags && tweet.hashtags.length > 0) {
      const hashtags = tweet.hashtags
        .map((tag: string) => `#${tag}`)
        .join(' ');
      tweetParts.push(p(hashtags));
    }

    // Metadata
    const metadata: string[] = [];
    if (tweet.tone) {
      metadata.push(`${strong('Tone:')} ${tweet.tone}`);
    }
    if (tweet.content) {
      const remaining = 280 - tweet.content.length;
      metadata.push(`${strong('Chars:')} ${remaining}`);
    }
    if (metadata.length > 0) {
      tweetParts.push(p(metadata.join(' • ')));
    }

    return tweetParts.join('');
  });

  sections.push(tweets.join(hr()));

  return wrapHTML(sections.join(''));
};

